export default {"src":"/_next/static/media/icon-2.1fb08aca.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};